//key helpers
export const keyUser = (id: string) => `u:${id}`;
export const keyGroup = (id: number) => `g:${id}`;

export function hasUnreadMessages(
    type: "user" | "group",
    id: string | number,
    clearedUnread: Record<string, boolean>, 
    unreadUserIds: string[],
    hasUnreadMessages?: boolean,
    incomingMessages?: any[],
    activeRecipient?: { id: string } | null,
    activeGroup?: { id: number } | null,
) {
    const key = type === "user" ? keyUser(id as string) : keyGroup(id as number);
    const hasServerUnread = !!hasUnreadMessages && !clearedUnread[key];

    let hasIncoming = false;
    if (type === "user") {
        hasIncoming = unreadUserIds.includes(id as string);
    } else {
        hasIncoming = incomingMessages?.some((m: any) => m.groupId === id) ?? false;
    }

    if (type === "user") {
        return (hasServerUnread || hasIncoming) &&
            (!activeRecipient || activeRecipient.id !== id);
    } else {
        return (hasServerUnread || hasIncoming) &&
            (!activeGroup || activeGroup.id !== id);
    }
}




